import { render, staticRenderFns } from "./TractSpeciesCostDetail.vue?vue&type=template&id=96e710f4&"
import script from "./TractSpeciesCostDetail.vue?vue&type=script&lang=js&"
export * from "./TractSpeciesCostDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports